/**
 * Bereich-Chip (F9) — zentrale Anzeige des Bereichs (PU/Service/MTB) inkl.
 * neutralem Fallback "offen" wenn weder SF-Wert noch Override gesetzt ist.
 * Eine Quelle für Farbe + Label, genutzt von Phase-Board-Karte, Atlas-Karte,
 * HandoverCard und ResponsibilityPicker-Umfeld. Tokens existieren in beiden Themes.
 */
import { useTranslation } from 'react-i18next';

export type BereichValue = 'PU' | 'Service' | 'MTB' | null | undefined;

type Tone = { fg: string; bg: string; border: string };

export function bereichColors(value: BereichValue): Tone {
  switch (value) {
    case 'PU':
      return { fg: 'var(--primary)', bg: 'var(--primary-soft)', border: 'var(--primary)' };
    case 'Service':
      return { fg: 'var(--success)', bg: 'var(--success-soft)', border: 'var(--success)' };
    case 'MTB':
      return { fg: 'var(--warn)', bg: 'var(--warn-soft)', border: 'var(--warn)' };
    default:
      return {
        fg: 'var(--bereich-open)',
        bg: 'var(--bereich-open-soft)',
        border: 'var(--bereich-open)',
      };
  }
}

export function BereichBadge({
  value,
  size = 'sm',
}: {
  value: BereichValue;
  size?: 'sm' | 'xs';
}) {
  const { t } = useTranslation();
  const tone = bereichColors(value);
  const label = value ?? t('v2.bereich.open', 'offen');
  return (
    <span
      className={
        size === 'xs'
          ? 'inline-flex items-center rounded px-1.5 py-0.5 text-[9.5px]'
          : 'inline-flex items-center rounded px-2 py-0.5 text-[10px]'
      }
      title={t('v2.bereich.label', 'Bereich')}
      style={{
        background: tone.bg,
        color: tone.fg,
        border: `1px solid ${tone.border}`,
        fontFamily: 'var(--f-mono)',
        lineHeight: 1.4,
      }}
    >
      {label}
    </span>
  );
}
